<template>
    <main class="showroom-detail" v-if="car">
        <h1>{{car.name}}</h1> 
        <h2>{{car.sub_name}}</h2>
        <p v-html="car.description"></p>
        <br>
        <h2>
            Car Information
        </h2>
        <div class="car-detail-table">
            <div class="car-detail" v-for="info in car.carinfo" :key="info.id">
                <div class="icon" :style="{'background-image': `url(${env.imageUrl + info.carinfocategory.thumb_image})`}"></div>
                <p>{{info.name}}</p>
            </div>
        </div>
        <!-- Section -->
        <section class="section section--gallery" v-if="car.carimage.length">
            <div class="secd-container">
                <div class="image-view">
                    <img v-lazy="env.imageUrl + car.carimage[index].image" alt="gallery image">
                </div>
                <div class="images">
                    <div class="image" 
                        @click="index = i"
                        v-for="(image, i) in car.carimage" :key="image.id"
                        :class="{'active': index === i}"
                        v-lazy:background-image.container="env.imageUrl + image.thumb_image"></div>
                </div>
                <div class="mobile-images">
                    <img class="image" v-lazy="{
                        src: env.imageUrl + image.image,
                        loading: env.imageUrl + image.thumb_image,
                    }" v-for="image in car.carimage" :key="image.id">
                </div>
            </div>
        </section>
        <h4>contact info</h4>
        <div class="contact-info">
            <div class="info info--address">
                <div>
                    <a target="_blank" :href="car.showroom.address_url">
                        {{car.showroom.address}}
                    </a>
                </div>
            </div>
            <div class="info info--phone">
                <div>
                    <a target="_blank" :href="'tel:' + phone" v-for="(phone, index) in car.showroom.phone.split('<br>')" :key="index">
                        {{phone}}
                    </a>
                </div>
            </div>
            <div class="info info--email">
                <div>
                    <a target="_blank" :href="isEmail(email)" v-for="(email, index) in car.showroom.email_website.split('<br>')" :key="index">
                        {{email}}
                    </a>
                </div>
            </div>
        </div>
    </main>
    <main class="showroom-detail loading" v-else>
        <div class="loading--icon"></div>
    </main>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import img from '../assets/images/home-banner.jpg'
import {env} from '../enviorments'

export default {
    name: 'car',
    data() {
        return {
            carId: null,
            index: 0,
            img,
            env,
        }
    },
    computed: {
        ...mapState({
            car: state => state.car,
        }),
    },
    methods: {
        ...mapActions({
            callCar: 'callCar',
        }),
        isEmail(addr) {
            if (addr.includes('@')) return 'mailto:' + addr
            else if (addr.startsWith('http')) return addr
            else return 'https://' + addr
        }
    },
    async mounted() {
        this.carId = this.$route.params.car
        if (this.carId) {
            await this.callCar(this.carId)
            console.log(this.car)
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/showroom.scss';
.showroom-detail {
    .car-detail-table {
        display: flex;
        flex-wrap: wrap;
        padding: 10px 10px 40px;
        .car-detail {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 10px 20px;
            .icon {
                width: 24px;
                height: 24px;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
            }
            &:nth-child(odd) {
                background-color: #eee;
            }
            @media (min-width: 768px) {
                width: 50%;
                &:nth-child(odd) {
                    background-color: #fff;
                }
                &:nth-child(4n+1),
                &:nth-child(4n+2) {
                    background-color: #eee;
                }
            }
        }
    }
}
</style>
